import React from 'react';
import { observer, inject } from 'mobx-react';
import { toJS } from 'mobx';

@inject('sysStore')
@observer
class Main extends React.Component {
  static defaultProps = {
    prefixCls: 'sys-basic'
  }
  
  render() {
    const { prefixCls } = this.props;
    let { sysStore: { sysPerson } } = this.props;
    sysPerson = toJS(sysPerson).Member || {};
    return (
      <div className={`${prefixCls}`}>
        <div className={`${prefixCls}-row`}>
          <span className={`${prefixCls}-row-label`}>用户名：</span>
          <span className={`${prefixCls}-row-wrapper`}>{sysPerson.m_name}</span>
        </div>
        <div className={`${prefixCls}-row`}>
          <span className={`${prefixCls}-row-label`}>用户类型：</span>
          <span className={`${prefixCls}-row-wrapper`}>{sysPerson.m_role}</span>
        </div>
        <div className={`${prefixCls}-row`}>
          <span className={`${prefixCls}-row-label`}>岗位：</span>
          <span className={`${prefixCls}-row-wrapper`}>{sysPerson.m_position}</span>
        </div>
        <div className={`${prefixCls}-row`}>
          <span className={`${prefixCls}-row-label`}>公司：</span>
          <span className={`${prefixCls}-row-wrapper`}>{sysPerson.m_Comname}</span>
        </div>
        <div className={`${prefixCls}-row`}>
          <span className={`${prefixCls}-row-label`}>分部：</span>
          <span className={`${prefixCls}-row-wrapper`}>{sysPerson.m_branch}</span>
        </div>
        <div className={`${prefixCls}-row`}>
          <span className={`${prefixCls}-row-label`}>部门：</span>
          <span className={`${prefixCls}-row-wrapper`}>{sysPerson.m_department}</span>
        </div>
      </div>
    )
  }
}

export default Main;


// WEBPACK FOOTER //
// ./src/components/sys/basic/User.js